import { INDIVIDUALIZATION_REQUEST } from './INDIVIDUALIZATION_REQUEST.js';
import { LICENSE_RELEASE } from './LICENSE_RELEASE.js';
import { LICENSE_RENEWAL } from './LICENSE_RENEWAL.js';
import { LICENSE_REQUEST } from './LICENSE_REQUEST.js';
/**
 * Media Key Message Types.
 *
 * @group DRM
 *
 * @beta
 */
export const MediaKeyMessageType = {
    LICENSE_REQUEST: LICENSE_REQUEST,
    LICENSE_RENEWAL: LICENSE_RENEWAL,
    LICENSE_RELEASE: LICENSE_RELEASE,
    INDIVIDUALIZATION_REQUEST: INDIVIDUALIZATION_REQUEST,
};
//# sourceMappingURL=MediaKeyMessageType.js.map